import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=56a40fc7&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=js"
export * from "./Employees.vue?vue&type=script&lang=js"
import style0 from "./Employees.vue?vue&type=style&index=0&id=56a40fc7&lang=css"
import style1 from "./Employees.vue?vue&type=style&index=1&id=56a40fc7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a40fc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a40fc7')) {
      api.createRecord('56a40fc7', component.options)
    } else {
      api.reload('56a40fc7', component.options)
    }
    module.hot.accept("./Employees.vue?vue&type=template&id=56a40fc7&scoped=true", function () {
      api.rerender('56a40fc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/Employees.vue"
export default component.exports